module.exports = __webpack_public_path__ + "static/media/LibertadMono-Thin.edf42cd8.woff2";